"use client"
import Link from "next/link"
import { useState, useEffect } from "react"

// Derived from the same env vars the analytics components read, so the banner
// can never again promise "no third-party tracking" while loading trackers.
// Vercel Web Analytics is always listed: it ships with the deployment.
const TRACKERS = [
  "Vercel Web Analytics",
  ...(process.env.NEXT_PUBLIC_GA4_ID ? ["Google Analytics"] : []),
  ...(process.env.NEXT_PUBLIC_CLARITY_ID ? ["Microsoft Clarity"] : []),
  ...(process.env.NEXT_PUBLIC_FB_PIXEL_ID ? ["the Meta pixel"] : []),
]
const TRACKER_SENTENCE =
  TRACKERS.length === 1
    ? TRACKERS[0]
    : TRACKERS.slice(0, -1).join(", ") + " and " + TRACKERS[TRACKERS.length - 1]

export default function CookieConsent() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem("ze_cookie_consent")) setShow(true)
  }, [])

  function accept() {
    localStorage.setItem("ze_cookie_consent", "true")
    window.dispatchEvent(new Event("ze:consent"))
    setShow(false)
  }

  function decline() {
    localStorage.setItem("ze_cookie_consent", "false")
    setShow(false)
  }

  if (!show) return null

  return (
    <div style={{
      position: "fixed", bottom: 0, left: 0, right: 0,
      background: "var(--navy)",
      borderTop: "2px solid var(--gold)",
      padding: "16px 24px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      gap: 16, zIndex: 300, flexWrap: "wrap",
    }}>
      <p style={{ fontSize: 13, color: "rgba(253,251,247,0.8)", maxWidth: 680, lineHeight: 1.6, margin: 0 }}>
        {/* This used to claim "No third-party tracking", which was false — Vercel
            Web Analytics loaded regardless of consent, and accepting also loads
            GA/Clarity/Meta where configured. The list is derived from the env so
            it cannot drift out of date again. */}
        We use cookies to keep you signed in. If you accept, we also load {TRACKER_SENTENCE} to see
        how the site is used. Decline and none of them load.{" "}
        <Link href="/privacy" style={{ color: "var(--gold)", textDecoration: "underline" }}>Privacy Policy</Link>
      </p>
      <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
        <button onClick={decline} style={{ padding: "8px 18px", border: "1px solid rgba(253,251,247,0.25)", borderRadius: 8, background: "transparent", color: "rgba(253,251,247,0.7)", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
          Decline
        </button>
        <button onClick={accept} style={{ padding: "8px 20px", background: "var(--gold)", border: "none", borderRadius: 8, color: "var(--navy)", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
          Accept cookies
        </button>
      </div>
    </div>
  )
}
